import { Toast, Typography } from '@chilecompra/react-kit/components'
import PropTypes from 'prop-types'

import { YES_NO_OPTIONS } from '../../../../config/settings/constants'
import {
  Container,
  Item,
  MoreInformationLink,
  Radio,
  Tooltip,
  TooltipIcon,
  TooltipText
} from '../../Cfmp.styles'
import { inputShape } from './CfmpForm.propTypes'

/**
 * The CfmpFormSustainablePurchase component.
 */
export const CfmpFormSustainablePurchase = ({
  environmentalPurchase,
  isDisabled = false,
  isSourcesLoading = false,
  onOpenMoreInfoDialog,
  socialEconomicPurchase
}) => {
  return (
    <Container direction="column" spacing={2}>
      <Item container direction="column" size={12} spacing={1}>
        <Typography fontWeight="bold" variant="body2">
          ¿Esta compra consideró requisitos medioambientales?
          <Tooltip
            content={
              <TooltipText>
                Se refiere a una compra que incluye requisitos que se enfocan en el equilibrio entre
                el uso de recursos naturales y el impacto que las actividades tienen en el medio
                ambiente, priorizando la eficiencia energética, el reciclaje de materiales y la
                reducción de la huella ecológica. Es una contratación que integra prácticas que
                minimicen el daño al ecosistema y promuevan el uso responsable de recursos
                renovables.
              </TooltipText>
            }
          >
            <TooltipIcon size="large" />
          </Tooltip>
        </Typography>

        <Radio
          direction="horizontal"
          disabled={isDisabled}
          error={environmentalPurchase.errorText}
          loading={isSourcesLoading}
          onChange={environmentalPurchase.input.onChange}
          options={YES_NO_OPTIONS}
          value={environmentalPurchase.input.value}
        />
      </Item>

      <Item container direction="column" size={12} spacing={1}>
        <Typography fontWeight="bold" variant="body2">
          ¿Esta compra consideró requisitos con impacto social o económico?
          <Tooltip
            content={
              <TooltipText>
                Se refiere a una compra que incluye requisitos que se enfocan en procurar mejores
                condiciones sociales, laborales y económicas, buscando, junto con la generación de
                valor económico, el fortalecimiento del tejido social, laboral y promuevan la
                justicia y bienestar para las comunidades.
              </TooltipText>
            }
          >
            <TooltipIcon size="large" />
          </Tooltip>
        </Typography>

        <Radio
          direction="horizontal"
          disabled={isDisabled}
          error={socialEconomicPurchase.errorText}
          loading={isSourcesLoading}
          onChange={socialEconomicPurchase.input.onChange}
          options={YES_NO_OPTIONS}
          value={socialEconomicPurchase.input.value}
        />
      </Item>

      <Toast severity="info">
        Consulta más información sobre estos requisitos. <br />
        <MoreInformationLink onClick={onOpenMoreInfoDialog}>
          Ver más información
        </MoreInformationLink>
      </Toast>
    </Container>
  )
}

CfmpFormSustainablePurchase.propTypes = {
  environmentalPurchase: inputShape.isRequired,
  isDisabled: PropTypes.bool,
  isSourcesLoading: PropTypes.bool,
  onOpenMoreInfoDialog: PropTypes.func.isRequired,
  socialEconomicPurchase: inputShape.isRequired
}
